import React, { Component, Fragment } from 'react'
import { MDBContainer, MDBBtn, MDBRow, MDBCol, MDBBreadcrumb, MDBBreadcrumbItem, MDBSpinner } from 'mdb-react-ui-kit'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import { toast } from 'react-toastify'
import ResourceTypeFactory from './../../shared/factories/resource-type.factory'
import ResourceTypeService from './../../shared/services/ResourceType.service'

import './AddResourceTypePage.scss'

class AddResourceTypePage extends Component {
  state = {
    loading: false,
    breakWidth: 1300,
    windowWidth: 0,
    rt_name: '',
    resourcetype_id: '',
    errorMessage: '',
    formError: false,
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props
    this.setState({ urlParams: params })
    if (params && params.id) this.fetchResourceTypeData(params.id)
  }

  #onChange = event => this.setState({ [event.target.name]: event.target.value })

  fetchResourceTypeData = async id => {
    this.setState({ loading: true })
    const ResourceType = await ResourceTypeFactory.findById(id)
    this.setState({ loading: false })
    if (ResourceType) {
      this.setState({ rt_name: ResourceType.get('rt_name') })
    } else {
      toast.error('Something went wrong!', {
        position: toast.POSITION.TOP_RIGHT,
      })
    }
  }

  validate = async () => {
    const { rt_name } = this.state
    if (!rt_name || !rt_name.trim()) {
      this.setState({
        formError: true,
        errorMessage: 'Resource Type Required!',
      })
      return
    }
    this.setState({ formError: false, errorMessage: '' })
  }

  createResourceType = async () => {
    await this.validate()
    const { errorMessage, formError, loading, rt_name } = this.state
    const id = this.state.urlParams.id
    if (loading) {
      return
    }

    if (formError) {
      toast.error(errorMessage, { position: toast.POSITION.TOP_RIGHT })
      return
    }

    const data = { rt_name }

    this.setState({ loading: true })

    const save = id ? ResourceTypeService.update(id, data) : ResourceTypeService.store(data)
    save
      .then(result => {
        this.setState({ loading: false })
        this.props.history.push('/admin-resourceType')
        toast.success(`Resource Type ${id ? 'updated' : 'created'} successfully`, {
          position: toast.POSITION.TOP_RIGHT,
        })
      })
      .catch(error => {
        this.setState({ loading: false })
        toast.error(error.message, { position: toast.POSITION.TOP_RIGHT })
      })
  }

  render() {
    toast.configure()
    const { urlParams, loading } = this.state

    return (
      <Fragment>
        <DashboardLayout>
          <main id='AddResourceTypePage' className='mainSection'>
            <MDBContainer fluid className='mt-5'>
              <MDBBreadcrumb>
                <MDBBreadcrumbItem>
                  <a href='/admin-resourceType'>List</a>
                </MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>
                  {!!(urlParams && urlParams.id) ? 'Edit Resource Type' : 'Add Resource Type'}
                </MDBBreadcrumbItem>
              </MDBBreadcrumb>
              <h2>{!!(urlParams && urlParams.id) ? 'Edit Resource Type' : 'Add Resource Type'}</h2>
              <hr />
              {loading ? (
                <div className='loadingOverlay'>
                  <h4 className={'loader-text p4'}>
                    <MDBSpinner />
                  </h4>
                </div>
              ) : (
                ''
              )}
              <MDBRow>
                <MDBCol size='6'>
                  <form className='content-wrapper form-controls-bordered'>
                    <div className='form-row'>
                      <div className='form-group col-md-6'>
                        <label className='grey-text' htmlFor='rt_name'>
                          Resource Type
                        </label>
                        <input
                          type='text'
                          className='form-control text-capitalize'
                          name='rt_name'
                          id='rt_name'
                          value={this.state.rt_name}
                          onChange={event => {
                            this.setState({ rt_name: event.target.value })
                          }}
                        />
                      </div>
                    </div>
                    <div className='form-row text-center mt-4'>
                      <MDBBtn color='unique' type='button' className='btn-block' onClick={this.createResourceType}>
                        {loading ? 'Saving...' : 'Save'}
                      </MDBBtn>
                    </div>
                  </form>
                </MDBCol>
              </MDBRow>
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default AddResourceTypePage
